import React from 'react';
import { PROJECTS as DATA } from './data';
import LandPage from './LandPage';
import Footer from './Footer';
import ShowCase from './ShowCase';
import MoreProjects from '../MoreProjects';

const Home = () => (
  <div>
    <div className="container">
      <LandPage />
      <div id="work">
        {DATA.map(d => (
          <ShowCase
            key={d.name}
            title={d.title}
            name={d.name}
            summary={d.summary}
            types={d.types}
            date={d.date}
            preImg={d.preImg}
            href={d.href}
            isConfidential={d.isConfidential}
          />
        ))}
      </div>
      <MoreProjects />
    </div>
    <Footer />
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/Modules/Home/Home.js